import BaseModelInstance from './base.model'
import { LedgerTransactionRule as ModelDefinition } from './model-definitions'

class LedgerTransactionRule extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default LedgerTransactionRule
